import "react-datepicker/dist/react-datepicker.css";
import React from "react";
import { MaskedTextBoxProps } from "@progress/kendo-react-inputs";
import { CustomMaskedTextBox } from "./CustomMaskedTextBox";

export const PhoneInput: React.FC<MaskedTextBoxProps> = ({
  mask,
  placeholder,
  ...allProps
}) => {
  return (
    <CustomMaskedTextBox
      mask="(000) 000-0000"
      {...allProps}
    />
  );
};
